import GetMapItemsAsyncRequestModelBase from '../_generated/modelBases/get-map-items-async-request-model-base';

export default class GetMapItemsAsyncRequestModel extends GetMapItemsAsyncRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
